import DynamicPage from 'util/hoc/dynamic-page';

export default DynamicPage(async () => (
  await import(/* webpackChunkName: "hs-planning/app" */ 'apps/hs-planning/app')
));
